import * as actions from './slice'

const getAuthors = {
  eventName: 'authorList',
  onSuccess: [{ action: actions.setAuthors, redux: true }]
}

export { getAuthors }
